import styled from 'styled-components';
import IconChevronDown from './IconChevronDown';
var IconChevronRight = /*#__PURE__*/styled(IconChevronDown).withConfig({
  displayName: "IconChevronRight",
  componentId: "c11n-8-111-1__sc-19mpgrq-0"
})(["transform:rotate(270deg);"]);
export default IconChevronRight;